import {Component, Input, OnInit} from '@angular/core';
import {AbstractControl, UntypedFormGroup, ReactiveFormsModule} from '@angular/forms';
import {RequiredComponent} from '../../../../common/forms/required/required.component';
import {ValidationErrorsComponent as ValidationErrorsComponent_1} from '../../../../common/forms/validation-errors/validation-errors.component';
import {KeyValuePipe} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';

@Component({
    selector: 'app-hawk-type',
    templateUrl: './hawk-type.component.html',
    styleUrls: ['./hawk-type.component.scss'],
    imports: [ReactiveFormsModule, RequiredComponent, ValidationErrorsComponent_1, KeyValuePipe, TranslateModule]
})
export class HawkTypeComponent implements OnInit {

  @Input() formGroup: UntypedFormGroup;
  @Input() control: AbstractControl;
  @Input() hawkTypes: Map<string, string>;

  /**
   * This gets passed to the nested validation-error components.
   *
   * @see {@link ValidationErrorsComponent.displayErrors}
   */
  @Input() displayErrors: boolean = false;

  constructor() { }

  ngOnInit(): void {
  }

}
